var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-content"},[_c('img',{staticClass:"s",attrs:{"src":_vm.imageSUrl}}),_c('img',{staticClass:"m",attrs:{"src":_vm.imageMUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }